module.exports = __webpack_public_path__ + "static/media/study 201112.0ed2b581.png";